import React from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useCreditRecharge } from "../contexts/CreditRechageContext";
import { useWorkspace } from "../contexts/WorkspaceContext";

const CommanModalForAlert = () => {
  const {
    showAlertModal,
    setShowAlertModal,
    setShowCreditRecharge,
  } = useCreditRecharge();

  const { alertCallPlace } = useWorkspace();

  const handleClose = () => setShowAlertModal(false);

  const handleButtonClick = () => {
    if (alertCallPlace === "TrackWithModalX") {
      setShowAlertModal(false);
    } else if (alertCallPlace === "VideoGeneration") {
      setShowCreditRecharge(true);
      setShowAlertModal(false);
    }
  };

  // Dynamic title:
  const modalTitle =
    alertCallPlace === "TrackWithModalX"
      ? "Website Tracking Restricted"
      : alertCallPlace === "VideoGeneration"
      ? "Video Generation Restricted"
      : "Alert";

  return (
    <Modal
        open={showAlertModal}
        onClose={handleClose}
        container={() => document.body}
        disablePortal={false}
        keepMounted
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999
        }}
      >

      <Box
          sx={{
            width: "90%",        // responsive width
            maxWidth: "480px",   // limit on large screens
            maxHeight: "90vh",   // fit inside mobile view
            overflowY: "auto",   // scroll if content is big
            borderRadius: "10px",
            backgroundColor: "rgba(40, 45, 81, 1)",
            border: "1px solid rgba(255,255,255,0.15)",
            p: 2,
          }}
        >
        {/* HEADER */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid rgba(255,255,255,0.15)",
            pb: 1.5,
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 600,
              color: "#fff",
            }}
          >
            {modalTitle}
          </Typography>

          <IconButton onClick={handleClose} sx={{ color: "#fff" }}>
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        {/* MESSAGE CONTENT */}
        <Box sx={{ mt: 3, px: 1 }}>
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "22px",
              color: "#fff",
              textAlign: "left",
            }}
          >
            {alertCallPlace === "TrackWithModalX" ? (
              <>
                Website tracking is only available to North American users with
                an active subscription.
                <br />
                <br />
                If you're accessing the platform from another region or without
                a subscription, this feature will remain unavailable at the
                moment.
              </>
            ) : alertCallPlace === "VideoGeneration" ? (
              <>
                The video generation feature is available only for paid users.
                <br />
                <br />
                Please activate a subscription plan to enable video creation.
              </>
            ) : (
              ""
            )}
          </Typography>
        </Box>

        {/* BUTTON */}
        <Button
          variant="contained"
          fullWidth
          onClick={handleButtonClick}
          sx={{
            mt: 3,
            backgroundColor: "rgba(246, 190, 107, 1)",
            color: "#000",
            fontWeight: 600,
            textTransform: "none",
            fontSize: "16px",
            borderRadius: "6px",
            height: "42px",
            "&:hover": { bgcolor: "#ffd9aa" },
          }}
        >
          {alertCallPlace === "TrackWithModalX"
            ? "Close"
            : "Subscribe to Pro"}
        </Button>
      </Box>
    </Modal>
  );
};

export default CommanModalForAlert;
